import PricingListItem from '../../../../Domain/PricingListItem';
import InputTypesEnum from '../../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../../Helpers/ValidityHelper';
import PricingService from '../../../../Services/PricingService';

// Drives the GeneralEditWizzardBaseFigma bulk "Pricing Detail Multi Update" action panel. Each
// per-eval cost field carries isCheckBoxEnabled so it is opted in/out of the multi-update
// (MultiplePost strips fields whose <field>Status is false). 5 visible fields keep it compact.
export default class PricingDetailMulitpleEditWindowDescription {
  static titleForCreate = 'Pricing Detail Multi Update';
  static titleForEdit = 'Pricing Detail Multi Update';
  static finishButtonLabel = 'Save';
  static itemType = PricingListItem;
  static serviceFunction = (edited) => PricingService.MultiplePost(edited);
  static messageOnSuccess = 'Pricing has been updated!';

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        //Tier
        {
          fieldName: 'ClientFeePerEval',
          label: 'Client Fee Per Eval',
          className: 'col-12',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.emptyValidityChecker,
          isCheckBoxEnabled: true,
        },
        {
          fieldName: 'EvalFeePerEval',
          label: 'Eval Fee Per Eval',
          className: 'col-12',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.emptyValidityChecker,
          isCheckBoxEnabled: true,
        },

        //PricingDetail
        {
          fieldName: 'EditorCostPerEval',
          label: 'Editor Cost Per Eval',
          className: 'col-12',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.emptyValidityChecker,
          isCheckBoxEnabled: true,
        },
        {
          fieldName: 'EvalBonusPerCycle',
          label: 'Evaluator Bonus Per Cycle',
          className: 'col-12',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.emptyValidityChecker,
          isCheckBoxEnabled: true,
        },
        {
          fieldName: 'SMCostPerEval',
          label: 'MSS Cost Per Eval',
          className: 'col-12',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.emptyValidityChecker,
          isCheckBoxEnabled: true,
        },
      ],
    },
  ];
}
